export function isAuthenticated(state, authenticated) {
  state.isAuthenticated = authenticated
}
